"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Toast_message_accessor_storage, _Toast_duration_accessor_storage, _Toast_theme_accessor_storage, _Toast_showToast_accessor_storage, _Toast_placement_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let Toast = class Toast extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _Toast_message_accessor_storage.set(this, '');
        _Toast_duration_accessor_storage.set(this, 2750);
        _Toast_theme_accessor_storage.set(this, 'info');
        _Toast_showToast_accessor_storage.set(this, false);
        _Toast_placement_accessor_storage.set(this, 'top');
    }
    get message() { return __classPrivateFieldGet(this, _Toast_message_accessor_storage, "f"); }
    set message(value) { __classPrivateFieldSet(this, _Toast_message_accessor_storage, value, "f"); }
    get duration() { return __classPrivateFieldGet(this, _Toast_duration_accessor_storage, "f"); }
    set duration(value) { __classPrivateFieldSet(this, _Toast_duration_accessor_storage, value, "f"); }
    get theme() { return __classPrivateFieldGet(this, _Toast_theme_accessor_storage, "f"); }
    set theme(value) { __classPrivateFieldSet(this, _Toast_theme_accessor_storage, value, "f"); }
    get showToast() { return __classPrivateFieldGet(this, _Toast_showToast_accessor_storage, "f"); }
    set showToast(value) { __classPrivateFieldSet(this, _Toast_showToast_accessor_storage, value, "f"); }
    get placement() { return __classPrivateFieldGet(this, _Toast_placement_accessor_storage, "f"); }
    set placement(value) { __classPrivateFieldSet(this, _Toast_placement_accessor_storage, value, "f"); }
    closeToast() {
        this.showToast = false;
        this.dispatchEvent(new CustomEvent('sup-forge-toast-close'));
        this.requestUpdate();
    }
    render() {
        return (0, lit_1.html) `
            <forge-toast
                dismissible
                .duration=${this.duration}
                .open=${this.showToast}
                .placement=${this.placement}
                theme=${this.theme}
                @forge-toast-close=${this.closeToast}
                >${this.message}</forge-toast
            >
        `;
    }
};
exports.Toast = Toast;
_Toast_message_accessor_storage = new WeakMap();
_Toast_duration_accessor_storage = new WeakMap();
_Toast_theme_accessor_storage = new WeakMap();
_Toast_showToast_accessor_storage = new WeakMap();
_Toast_placement_accessor_storage = new WeakMap();
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Toast.prototype, "message", null);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], Toast.prototype, "duration", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Toast.prototype, "theme", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Toast.prototype, "showToast", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Toast.prototype, "placement", null);
exports.Toast = Toast = __decorate([
    (0, decorators_js_1.customElement)('sup-toast')
], Toast);
